module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "introduction"
    }
  }, [_c('h1', [_vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_c('em', [_vm._v("9 June 1963 – 28 September 1972")])])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("In my first book, "), _c('em', [_vm._v("An Unlikely Cornish Fisherman "), _c('strong', [_vm._v("–")]), _vm._v(" The Early Years,")]), _vm._v(" I relate the period in my life from 1947 to 1963 and the first two of my eleven boats that I had owned, the "), _c('em', [_vm._v("Hilda")]), _vm._v(" and the "), _c('em', [_vm._v("Seahorse.")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Endeavour to Be a Cornish Fisherman")]), _vm._v(" is my story of a return to work as a crew member on my father’s fishing boat Endeavour FY 369, that I once ‘skippered’ for a week as a 17 year old college boy in 1954.")]), _vm._v(" "), _c('p', [_vm._v("On 13 June 1966, I answered the ‘one’ phone call that was to completely change my life’s direction. Thinking back to that moment, it puts me in mind of an expression my Great Grandfather, Thomas Toms, used quite often. He was the last coxswain of the old Looe rowing/sailing lifeboat, "), _c('em', [_vm._v("Ryder")]), _vm._v(" and the local Methodist, Lay Preacher.")]), _vm._v(" "), _c('p', [_vm._v("“The Lord moves in mysterious ways, his wonders to behold!”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a654880","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch005.vue
// module id = 75
// module chunks = 0